import {SaveState, TitleStateBlackList} from '@deliveriesondemand/dod-data';
import {Component} from 'react';
import {connect} from 'react-redux';

import {getNumberStipsToUploadSelector,stipListSelector} from '-/selectors';
import ApiService from '-/services/ApiService';
import VehicleInfoService from '-/services/VehicleInfoService';
import {fetchInfo} from '-/actions/actions';
import SaveButton from '-/components/general/SaveButton';
import StipsHeader from '-/components/general/StipsHeader';
import NavigationService from '-/services/NavigationService';
import ToastService from '-/services/ToastService';
import Form from '-/components/fields/Form';
import StepButtons from '-/components/general/StepButtons';
import {renderError} from '-/util/error';
import {get} from '-/util/lodash';

class StipsSubmitted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            stipsUploaded: props.stipsUploaded,
            stipsTotal: props.stipsTotal
        };
    }

    handleCloseButtonClick = e => {
        const {fetchInfo} = this.props;

        this.setState({saving: true});

        ApiService.setSaveState(SaveState.Saving, 'saveStateExplicit');
        fetchInfo().then(() => {
            ApiService.setSaveState(SaveState.Saved, 'saveStateExplicit');
            // let the animation play
            setTimeout(() => {
                NavigationService.startOver();
                ApiService.setSaveState(SaveState.NotSaved, 'saveStateExplicit');
            }, 500);
        }).catch(err => {
            ApiService.setSaveState(SaveState.Failed, 'saveStateExplicit');
            ToastService.addToastWithDuration(ToastService.DANGER, 5000, renderError(err));
        });
    };

    renderCloseButton() {
        const btn = <SaveButton title="Close" onClick={this.handleCloseButtonClick} />;

        return <StepButtons buttons={btn} />;
    }

    render() {
        const {
            loanType,
            stipsUploaded,
            stipsTotal,
            saving
        } = this.state;
        const {allStips} = this.props;

        const submittedAll = stipsUploaded === stipsTotal;

        let submittedVIN = false;
        let vehicle = null;

        if (allStips && allStips.length == 1) {
            let [stip] = allStips;

            if (stip.stipType === 'VIN') {
                submittedVIN = true;
                vehicle = get(stip, 'docs[0].subtitle');
            }
        }

        const titleState = get(this.props, 'vehicleInfo.title.state');

        return (
            <div className="center">
                <Form standalone={true}>
                    <StipsHeader showApplicantTypeButton={false} saving={saving} />
                    {!submittedAll && (
                        <p className="info">
                            <strong>Submitted {stipsUploaded} out of {stipsTotal}!</strong>
                        </p>
                    )}
                    {!submittedAll ? (
                        <div>
                            <p className="info">Thank you for submitting your documents. They will be verified shortly.</p>
                            <p className="info">Please remember to upload the rest of your documents whenever you get a chance.</p>
                            <p className="info"><strong>**You can click on the same link to upload the rest of the documents**</strong></p>
                        </div>
                    ) : submittedVIN ? (
                        <div>
                            <p className="info">Thank you for submitting your VIN for the {vehicle}.</p>
                            <p className="info">Within 24 to 48 hours you will hear back about your final loan decision from someone on our team.</p>
                            <p className="smallInfo">If you have any questions, please call the number below.</p>
                        </div>
                    ) : (
                        <div>
                            <p className="info">Thank you for submitting all your documents.</p>
                            <p className="info">We look forward to seeing you at your appointment.</p>
                            {!TitleStateBlackList.includes(titleState) && loanType === 'refinance' && 
                                <p className="info">**Don’t forget to bring your car title**</p>
                            }
                        </div>
                    )}
                </Form>
                {this.renderCloseButton()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {applicantType} = state.stips;
    const {stipsUploaded, stipsTotal} = getNumberStipsToUploadSelector(state);
    const loanType = get(state, 'dealInfo.loanType');

    return {
        stipsUploaded,
        stipsTotal,
        applicantType,
        allStips: stipListSelector(state),
        loanType,
        vehicleInfo: VehicleInfoService.getReducerState()
    };
};

export default connect(mapStateToProps, {fetchInfo})(StipsSubmitted);
